import { ReferenceData } from '../../../App/apiWrapper';
import { RefIdType } from '../../../App/types';

export const getSelectedValues = (options: ReferenceData[], values: RefIdType[]) =>
  options.filter((option) => {
    return values.indexOf(option.id) >= 0;
  });
